import React from "react";
import { Helmet } from "react-helmet";
import CourseCategory from "./CourseCategory";
import CoursesMain from "./CoursesMain";

function index() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Our Courses</title>
        <meta
          name="description"
          content="Check out our finest courses on Programming, Digital Marketing and Soft Skills for students of colleges and schools. Each course is designed and customized accordingly to grasp effective knowledge &amp; skills in less time."
        />
      </Helmet>
      <CoursesMain />
      <CourseCategory />
    </>
  );
}

export default index;
